module.exports = __webpack_public_path__ + "img/personal2.1219a9cd.png";